import gql from "graphql-tag";

export default gql`
  mutation addCreditCommentary(
    $friendly_entity_id: String!
    $effective_time: String!
    $category: String!
    $detail: String!
    $current: Boolean!
    $user: String!
  ) {
    addCreditCommentary(
      friendly_entity_id: $friendly_entity_id
      effective_time: $effective_time
      category: $category
      detail: $detail
      current: $current
      user: $user
    ) {
      __typename
      id
      friendly_entity_id
      subject_type
      subject_id
      effective_time
      category
      detail
      current
      user
    }
  }
`;
